<script lang="ts" setup>
const props = defineProps({
  number: {
    type: String,
    default: '1',
  },
});
</script>

<template>
  <div class="number-card flex">
    <div class="number-card__item" :class="`number-card__${props.number}`"></div>
    <p class="my-0 ml-8px mr-0 w-208px leading-24px">
      <slot></slot>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.number-card {
  &.flex {
    .number-card__item {
      @apply h-48px w-72px bg-[rgba(17,128,255,0.2)];
    }
  }

  @for $i from 1 through 10 {
    .number-card__#{$i} {
      @apply i-home-icons:number-#{$i};
    }
  }
}
</style>
